import { render, staticRenderFns } from "./inverterDetailNew.vue?vue&type=template&id=3082bfd5&scoped=true"
import script from "./inverterDetailNew.vue?vue&type=script&lang=js"
export * from "./inverterDetailNew.vue?vue&type=script&lang=js"
import style0 from "./inverterDetailNew.vue?vue&type=style&index=0&id=3082bfd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082bfd5",
  null
  
)

export default component.exports